import React, { useState } from "react";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link, useNavigate } from "react-router-dom";
import { Collapse } from "@material-ui/core";
import SearchBar from "material-ui-search-bar";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { fetchWithToken } from "../../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "id", label: "ID" },
  { id: "dnsSiteCode", label: "DNS" },
  { id: "name", label: "Name" },
  { id: "country", label: "Country" },
  { id: "state", label: "State" },
  { id: "city", label: "City" },
];

function SitesTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    setSearched,
    setPage,
    clearAlert,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
    clearAlert();
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    clearAlert();
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell style={{ width: "81px" }} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding="50px"
            style={{ fontSize: ".9vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <div
              class="input-group"
              style={
                headCell.id === "name"
                  ? {
                      justifyContent: "center",
                      marginBottom: "12px",
                      minWidth: "165px",
                      maxWidth: "250px",
                    }
                  : {
                      justifyContent: "center",
                      marginBottom: "12px",
                      width: "165px",
                    }
              }
            >
              {headCell.id == "id" && (
                <SearchBar
                  placeholder="ID"
                  value={
                    searchedObj.domain === "id" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "id")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "dnsSiteCode" && (
                <SearchBar
                  placeholder="DNS"
                  value={
                    searchedObj.domain === "dnsSiteCode"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) =>
                    handleInput(searchVal, "dnsSiteCode")
                  }
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "name" && (
                <SearchBar
                  placeholder="Name"
                  value={
                    searchedObj.domain === "name" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "name")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "country" && (
                <SearchBar
                  placeholder="Country"
                  value={
                    searchedObj.domain === "country" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "country")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "83%" }}
                />
              )}
              {headCell.id == "state" && (
                <SearchBar
                  placeholder="State"
                  value={
                    searchedObj.domain === "state" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "state")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "83%" }}
                />
              )}
              {headCell.id == "city" && (
                <SearchBar
                  placeholder="City"
                  value={
                    searchedObj.domain === "city" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "city")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "83%" }}
                />
              )}

              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </div>
          </TableCell>
        ))}
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", paddingBottom: "25px" }}
        >
          Pools
        </TableCell>
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", paddingBottom: "25px" }}
        >
          Edit
        </TableCell>
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", paddingBottom: "25px" }}
        >
          Delete
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
  smallColumn: {
    width: "10px",
  },
}));

const SitesTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { tableTitle } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography
        className={classes.title}
        variant="h5"
        id="tableTitle"
        component="div"
      >
        {tableTitle}
      </Typography>
    </Toolbar>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchbar: {
    width: "200px",
    height: "40px",
  },
}));

const SitesTable = (props) => {
  const { data, isAdmin, title } = props;
  const history = useNavigate();
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [rows, setRows] = useState(data);
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

  const handleFilter = () => {
    const filteredRows = rows.filter((row) => {
      if (searchedObj.domain === "id" && row.id != null) {
        return row.id
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "dnsSiteCode" && row.dnsSiteCode == null) {
        return;
      }
      if (searchedObj.domain === "dnsSiteCode" && row.dnsSiteCode != null) {
        return row.dnsSiteCode
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "name" && row.name != null) {
        return row.name
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "country" && row.country != null) {
        return row.country
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "state" && row.state != null) {
        return row.state
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "city" && row.city != null) {
        return row.city
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  let success = false;

  const handleDelete = (id) => {
    fetchWithToken(`api/Sites/${id}`, "DELETE")
      .then((res) => {
        if (res.ok) success = true;
        return res.json();
      })
      .then((data) => {
        sendAlert(data.returnMessage, success ? "success" : "error");
        if (success) setRows(rows.filter((row) => row.id !== id));
      });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const handleChangePage = (event, newPage) => {
    clearAlert();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    clearAlert();
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, handleFilter().length - page * rowsPerPage);

  return (
    <>
      <div className={classes.root}>
        <Snackbar
          className={classes.snack}
          open={alertMessage.active}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert severity={alertMessage.varient} onClose={() => clearAlert()}>
            {alertMessage.message}
          </Alert>
        </Snackbar>
        <Paper className={classes.paper}>
          <SitesTableToolbar tableTitle={title} />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <SitesTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                searchedObj={searchedObj}
                setSearched={setSearched}
                setPage={setPage}
                clearAlert={clearAlert}
              />

              <TableBody>
                <TableRow />
                {stableSort(handleFilter(), getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <>
                        {row.secondarySites.length > 0 ? (
                          <SiteWithSecondary
                            index={index}
                            key={row.name}
                            row={row}
                            isAdmin
                          />
                        ) : (
                          <TableRow
                            hover
                            tabIndex={-1}
                            style={{
                              height: "80px",
                              background: index % 2 ? "#f8f8f8" : "white",
                            }}
                            key={row.name}
                          >
                            <TableCell style={{ width: "5%" }}></TableCell>
                            <TableCell style={{ width: "10%" }} align="center">
                              {row.id}
                            </TableCell>
                            <TableCell style={{ width: "10%" }} align="center">
                              {row.dnsSiteCode}
                            </TableCell>
                            <TableCell style={{ width: "20%" }} align="left">
                              {row.name}
                            </TableCell>
                            <TableCell style={{ width: "10%" }} align="left">
                              {row.country}
                            </TableCell>
                            <TableCell style={{ width: "10%" }} align="left">
                              {row.state}
                            </TableCell>
                            <TableCell style={{ width: "10%" }} align="left">
                              {row.city}
                            </TableCell>

                            <TableCell align="center" style={{ width: "5%" }}>
                              <Link
                                to={`/pools/bySite/${row.id}`}
                                style={{ textDecoration: "none" }}
                              >
                                <Button variant="contained" size="small">
                                  <VisibilityIcon />
                                </Button>
                              </Link>
                            </TableCell>
                            <TableCell align="center" style={{ width: "5%" }}>
                              <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => history(`/sites/edit/${row.id}`)}
                                disabled={!isAdmin}
                              >
                                <EditIcon />
                              </Button>
                            </TableCell>
                            <TableCell align="center" style={{ width: "5%" }}>
                              <Button
                                variant="contained"
                                size="small"
                                color="secondary"
                                onClick={(e) => {
                                  if (
                                    window.confirm(
                                      `Are you sure you wish to delete Site ${row.id}?`
                                    )
                                  )
                                    handleDelete(row.id);
                                }}
                                disabled={!isAdmin}
                              >
                                <DeleteIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    );
                  })}
                {emptyRows > 0 && handleFilter().length >= rowsPerPage && (
                  <TableRow style={{ height: 80 * emptyRows }}>
                    <TableCell colSpan={10} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 30, 50]}
            component="div"
            count={handleFilter().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
    </>
  );

  function SiteWithSecondary(props) {
    const { row, index, isAdmin } = props;
    const [open, setOpen] = React.useState(false);
    const [secondarySites, setSecondarySites] = useState(row.secondarySites);

    const [secondaryAlertMessage, setSecondaryAlertMessage] = useState({
      message: "",
      varient: "",
      active: false,
    });

    return (
      <React.Fragment>
        <TableRow
          className={classes.root}
          style={{
            height: "80px",
            background: index % 2 ? "#f8f8f8" : "white",
          }}
        >
          <TableCell
            style={{ width: "5% !important", borderBottom: "none" }}
            align="center"
          >
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell
            style={{ width: "10%", borderBottom: "none" }}
            align="center"
          >
            {row.id}
          </TableCell>
          <TableCell
            style={{ width: "10%", borderBottom: "none" }}
            align="center"
          >
            {row.dnsSiteCode}
          </TableCell>
          <TableCell
            style={{ width: "20%", borderBottom: "none" }}
            align="left"
          >
            {row.name}
          </TableCell>
          <TableCell
            style={{ width: "10%", borderBottom: "none" }}
            align="left"
          >
            {row.country}
          </TableCell>
          <TableCell
            style={{ width: "10%", borderBottom: "none" }}
            align="left"
          >
            {row.state}
          </TableCell>
          <TableCell
            style={{ width: "10%", borderBottom: "none" }}
            align="left"
          >
            {row.city}
          </TableCell>

          <TableCell
            style={{ width: "5%", borderBottom: "none" }}
            align="center"
          >
            <Link
              to={`/pools/bySite/${row.id}`}
              style={{ textDecoration: "none" }}
            >
              <Button variant="contained" size="small">
                <VisibilityIcon />
              </Button>
            </Link>
          </TableCell>
          <TableCell
            align="center"
            style={{ width: "5%", borderBottom: "none" }}
          >
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => history(`/sites/edit/${row.id}`)}
              disabled={!isAdmin}
            >
              <EditIcon />
            </Button>
          </TableCell>
          <TableCell
            align="center"
            style={{ width: "5%", borderBottom: "none" }}
          >
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={(e) => {
                if (
                  window.confirm(
                    `Are you sure you wish to delete Site ${row.id}?`
                  )
                )
                  handleDelete(row.id);
              }}
              disabled={!isAdmin}
            >
              <DeleteIcon />
            </Button>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Secondary Sites:
                </Typography>

                {secondaryAlertMessage.active && (
                  <Alert color={secondaryAlertMessage.varient}>
                    {secondaryAlertMessage.message}
                  </Alert>
                )}

                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Country</TableCell>
                      <TableCell>State</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>DNS</TableCell>
                      <TableCell align="center">Edit</TableCell>
                      <TableCell align="center">Delete</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <SecondarySitesDrop
                      index={index}
                      key={row.id}
                      row={row}
                      secondarySites={secondarySites}
                      setSecondarySites={setSecondarySites}
                      secondaryAlertMessage={secondaryAlertMessage}
                      setSecondaryAlertMessage={setSecondaryAlertMessage}
                      isAdmin
                    />
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
};

const SecondarySitesDrop = (props) => {
  const history = useNavigate();

  const {
    secondarySites,
    setSecondarySites,
    setSecondaryAlertMessage,
    isAdmin,
  } = props;

  const handleSecondaryDelete = (id) => {
    fetchWithToken(`api/SecondarySites/${id}`, "DELETE").then((res) => {
      if (res.ok) {
        console.log("Before", secondarySites.length);

        setSecondarySites(secondarySites.filter((r) => r.id !== id));
        sendSecondaryAlert(
          `Secondary Site ${id} - Successfully Deleted`,
          "success"
        );
        console.log("After", secondarySites.length);
      } else if (res.status === 409) {
        sendSecondaryAlert(
          `Conflict - Site ${id} has an attached Pool, Please delete Pool first`,
          "danger"
        );
      } else {
        sendSecondaryAlert(
          `Unknown Error - Error Deleting Site ${id}`,
          "warning"
        );
      }
    });
  };

  const sendSecondaryAlert = (message, varient) => {
    setSecondaryAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setSecondaryAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 8500);
  };

  return (
    <>
      {secondarySites.map((site, index) => {
        return (
          <TableRow
            style={{ backgroundColor: index % 2 ? "#f8f8f8" : "white" }}
          >
            <TableCell>{site.id}</TableCell>
            <TableCell>{site.name}</TableCell>
            <TableCell>{site.country}</TableCell>
            <TableCell>{site.state}</TableCell>
            <TableCell>{site.city}</TableCell>
            <TableCell>{site.dnsSiteCode}</TableCell>
            <TableCell align="center">
              <Button
                color="primary"
                onClick={() => history(`/secondarySites/edit/${site.id}`)}
                disabled={!isAdmin}
              >
                <EditIcon variant="contained" />
              </Button>
            </TableCell>
            <TableCell align="center">
              <Button
                color="secondary"
                onClick={(e) => {
                  handleSecondaryDelete(site.id);
                }}
                disabled={!isAdmin}
              >
                <DeleteIcon variant="contained" />
              </Button>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default SitesTable;
